const globalConfigs = require("./global-configs.ts");

export const PROJECT_NAME = globalConfigs.PROJECT_NAME;

export const PROJECT_REVISION = globalConfigs.PROJECT_REVISION;
export const WORKLOAD_URL_PROD = globalConfigs.WORKLOAD_URL_PROD;
export const WORKLOAD_URL_DEV = globalConfigs.WORKLOAD_URL_DEV;
export const MIDDLEEND_URL_PROD = globalConfigs.MIDDLEEND_URL_PROD;
export const MIDDLEEND_URL_DEV = globalConfigs.MIDDLEEND_URL_DEV;
export const MIDDLEEND_URL_LOCAL = globalConfigs.MIDDLEEND_URL_LOCAL;
export const LAYOUT_ALTERNATE_URLS = globalConfigs.LAYOUT_ALTERNATE_URLS;
export const PATH_ASSIGNED = globalConfigs.PATH_ASSIGNED;
export const FETCH_URL_EXPIRATION = globalConfigs.FETCH_URL_EXPIRATION;
export const AVAILABLE_SITES_PRD: Array<string> = globalConfigs.AVAILABLE_SITES_PRD;
export const AVAILABLE_SITES_DEV: Array<string> = globalConfigs.AVAILABLE_SITES_DEV;
export const SITES: Array<string> = globalConfigs.SITES;
export const DEVICE_TYPES = globalConfigs.DEVICE_TYPES;
export const COGNITO_CLIENTID_DEV = globalConfigs.COGNITO_CLIENTID_DEV;
export const COGNITO_CLIENTID_PROD = globalConfigs.COGNITO_CLIENTID_PROD;
export const COGNITO_BASE_CONFIG = globalConfigs.COGNITO_BASE_CONFIG;
export const COGNITO_CLIENTID_DEV_WEBVIEW = globalConfigs.COGNITO_CLIENTID_DEV_WEBVIEW;
export const COGNITO_CLIENTID_PROD_WEBVIEW = globalConfigs.COGNITO_CLIENTID_PROD_WEBVIEW;
export const ENV_PROD = globalConfigs.ENV_PROD;
export const ENV_DEV = globalConfigs.ENV_DEV;
export const APP_LAUNCHED = globalConfigs.APP_LAUNCHED;
export const FRONTEND_BOILERPLATE_VERSION = globalConfigs.FRONTEND_BOILERPLATE_VERSION;
export const HEADER_NAMES = globalConfigs.HEADER_NAMES;
export const COOKIE_NAMES = globalConfigs.COOKIE_NAMES;
export const AUTH_AUDIENCE = globalConfigs.AUTH_AUDIENCE;
export const AUTH_SCOPES = globalConfigs.AUTH_SCOPES;
export const BUTTER_CMS_API = globalConfigs.BUTTER_CMS_API;
